import React, {useState, useEffect} from 'react';
import Dropzone from 'react-dropzone';
import uploadImage from 'images/svg/upload-h.svg';
import Close from 'images/svg/closeButton.svg';
import pdfIcon from 'images/svg/pdfIcon.svg';
import wordIcon from 'images/svg/wordIcon.svg';
import {Form as RBForm, Image} from 'react-bootstrap';
import classNames from './candidate-portal.module.css';
import {useTranslation} from 'react-i18next';
import {toastService} from 'erp-react-components';

const FileUpload = (props) => {
  const {t} = useTranslation();
  const [uploadFile, setUploadFile] = useState([]);
  const {
    field,
    index,
    category_name,
    control,
    errors,
    customLabel,
    // importHandle,
    uploadFiles,
    setUploadFiles,
    uploadError,
    setUploadError,
    uploadedFile,
    setUploadedFile,
    removeOrSaveAction,
    setRemoveOrSaveAction,
    disable,
    setupdateChild,
    updateChild,
  } = props;

  useEffect(() => {
    if (removeOrSaveAction == false) {
      if (uploadedFile?.length > 0) {
        setUploadFile([]);
        setUploadedFile(uploadedFile);
      } else {
        setUploadFile([]);
      }
    }
  }, [uploadedFile]);

  useEffect(() => {
    if (uploadFiles?.length === 0) {
      setUploadFile([]);
    }
  }, [uploadFiles]);
  const importHandle = (files) => {
    setupdateChild(!updateChild);
    let tempArray = [];
    let obj = {};
    if (
      uploadFiles?.length &&
      (uploadFiles || []).find((u) => {
        return u?.qid == field.id;
      })
    ) {
      tempArray = (uploadFiles || []).map((u) => {
        if (u?.qid == field.id) {
          let validate = 0;
          const fileNames = (u.files || []).map((f) => {
            return f?.name;
          });
          (files || []).forEach((nf) => {
            if (fileNames.includes(nf?.name)) {
              validate += 1;
            } else {
              validate += 0;
            }
          });
          if (Number(validate) == 0) {
            return {...u, files: u.files.concat(files)};
          } else {
            toastService.error({
              msg: t('Duplicates not allowed'),
            });
            return {...u};
          }
        } else {
          return u;
        }
      });
    } else {
      tempArray = uploadFiles;
      obj = {
        qid: field.id,
        files: files,
      };
      tempArray.push(obj);
    }
    // let filterArray = [];
    // if (tempArray && tempArray.length > 0) {
    //   filterArray = tempArray.filter((f) => f.qid !== field.id);
    //   tempArray = filterArray;
    // }
    setUploadFiles(tempArray);
    setUploadFile(
      (tempArray || []).find((f) => {
        return f.qid == field.id;
      })?.files,
    );
  };

  return (
    <>
      <label className="">
        {customLabel || field.label}
        {field.is_mandatory ? (
          <span className={classNames['mandatory-color']}>*</span>
        ) : null}
      </label>
      <div className={classNames['file-upload']}>
        <Dropzone onDrop={importHandle} multiple={true}>
          {({getRootProps, getInputProps, isDragActive}) => (
            <div
              className={`mb-2 ${classNames['dropfile-in-documents']} ${
                field.is_mandatory == 1 ? classNames['file-border-color'] : ''
              }`}
              // style={
              //   field.is_mandatory == 1
              //     ? {borderColor: uploadError ? 'red' : ''}
              //     : {}
              // }
              {...getRootProps()}
            >
              <input
                type="file"
                disabled={disable ? true : false}
                id={field.id + 'fileUpload'}
                {...getInputProps()}
                accept=".pdf,.doc,.docx"
                onClick={() => {
                  setUploadError(false);
                }}
              />
              {/* .xls,.xlsx,.pdf,.csv,.doc,.docx,.txt, */}
              <div className={classNames['upload-text']}>
                {isDragActive
                  ? t('Apply_Job_Drop it Here!')
                  : t('Apply_Job_Drop your file or Upload')}
              </div>
              <div className="img-up">
                <Image src={uploadImage} />
              </div>
            </div>
          )}
        </Dropzone>

        {uploadFile &&
          (uploadFile || []).map((f, idx) => (
            <div
              className={'mb-2 ml-0 ' + classNames['uploadedAssets']}
              style={{display: 'inline-block'}}
              key={f.name}
            >
              <div className={classNames['uploadedAssetsClose']}>
                <img
                  style={{width: '16px'}}
                  src={Close}
                  onClick={() => {
                    setRemoveOrSaveAction(true);
                    setUploadFile((uf) => uf.filter((f, i) => i !== idx));
                    props.handleRemoveFiles(f, field.id, idx, 'newFile');
                  }}
                />
              </div>
              <div
                className={classNames['uploadedAssetsName']}
                style={{
                  padding: '0.50rem 1.6rem 0.50rem .6rem',
                }}
              >
                <img
                  src={
                    f.name?.includes('.pdf')
                      ? pdfIcon
                      : f.name?.includes('.doc' || '.docx')
                      ? wordIcon
                      : ''
                  }
                  className="mr-1"
                />
                {f.name}
              </div>
            </div>
          ))}
        {uploadedFile &&
          (uploadedFile || []).map((f, idx) =>
            field.id == f.question_id ? (
              <div
                className={'mb-2 ml-0 ' + classNames['uploadedAssets']}
                style={{display: 'inline-block'}}
                key={f.file_name}
              >
                <div className={classNames['uploadedAssetsClose']}>
                  {disable == 'applied' || disable == 'already-applied' ? (
                    ''
                  ) : (
                    <img
                      style={{width: '16px'}}
                      src={Close}
                      onClick={() => {
                        setRemoveOrSaveAction(true);
                        setUploadedFile((uf) => uf.filter((f, i) => i !== idx));
                        props.handleRemoveFiles(f, field.id, idx, 'oldFile');
                      }}
                    />
                  )}
                </div>
                <div
                  className={classNames['uploadedAssetsName']}
                  style={{
                    padding: '0.50rem 1.6rem 0.50rem .6rem',
                  }}
                >
                  <img
                    src={
                      f.file_name?.includes('.pdf')
                        ? pdfIcon
                        : f.file_name?.includes('.doc' || '.docx')
                        ? wordIcon
                        : ''
                    }
                    className="mr-1"
                  />
                  {f.file_name}
                </div>
              </div>
            ) : (
              ''
            ),
          )}
      </div>
    </>
  );
};

export default FileUpload;
